const imageUrl = {
    normal:
        'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="113" height="75"><text x="29" y="43" fill="%23dcdcdc" style="font-size: 14px;">鳳凰新聞</text></svg>',
    big:
        'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="345" height="194"><text x="120" y="108" fill="%23dcdcdc" style="font-size: 28px;">鳳凰新聞</text></svg>',
    none:
        'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="345" height="194"><rect x="0" y="0" width="349" height="196" fill="%23f2f2f2" /></svg>',
};

export default imageUrl;
